// งานของ super_user — ทุกหน้าใน /admin ผ่าน RequireSuperUser (ตรวจกับ Backend) ก่อนเรียกไฟล์นี้
import { db, fk, nowIso, newId, todayKey } from "./db";
import { getPricing, planById } from "./pricing";
import { balanceOf } from "./users";

export const admin = {
  async users() {
    const [rows, pricing] = await Promise.all([db.entries("users"), getPricing()]);
    return rows.map(([id, u]) => ({ id, ...u, balance: balanceOf(u, pricing) })).sort((a, b) => (a.createdAt < b.createdAt ? 1 : -1));
  },
  async payments() {
    const rows = await db.entries("payments");
    return rows.map(([id, v]) => ({ id, ...v })).sort((a, b) => (a.createdAt < b.createdAt ? 1 : -1));
  },
  async stats(days = 14) {
    const out = [];
    const all = (await db.get("stats/daily")) || {};
    for (let i = days - 1; i >= 0; i--) {
      const d = new Date(Date.now() - i * 86400000);
      const k = todayKey(d);
      out.push({ date: k, ...(all[k] || {}) });
    }
    return out;
  },
  /** ปรับ token ในกระเป๋า (+/-) พร้อมบันทึกเหตุผล */
  async adjustWallet(uid, delta, note) {
    const d = Math.round(Number(delta) || 0);
    if (!d) return;
    await db.transaction(`users/${fk(uid)}`, (u) => (u ? { ...u, wallet: Math.max(0, (Number(u.wallet) || 0) + d) } : undefined));
    await db.put(`wallet_tx/${fk(uid)}/${newId("w")}`, { type: "admin", tokens: d, note: note || "ผู้ดูแลปรับยอด", at: nowIso() });
  },
  /** ตั้งแพ็กเกจให้ผู้ใช้เอง (เช่น ชดเชย/ทดลองใช้) */
  async setPlan(uid, planId, months) {
    const pricing = await getPricing();
    planById(pricing, planId);
    if (planId === "free") return db.patch(`users/${fk(uid)}`, { plan: { id: "free" } });
    const end = new Date();
    end.setMonth(end.getMonth() + (Number(months) || 1));
    return db.patch(`users/${fk(uid)}`, { plan: { id: planId, cycle: "monthly", startedAt: nowIso(), expiresAt: end.toISOString(), byAdmin: true } });
  },
  ban: (uid, banned, reason) => db.patch(`users/${fk(uid)}`, { banned: !!banned, banReason: banned ? reason || "" : null }),
  async getModelOverrides() {
    return (await db.get("settings/models")) || {};
  },
  saveModelOverrides: (o) => db.put("settings/models", o),
};

/** settings/models (อ่านได้ทุกคน) */
export const getModelOverrides = async () => {
  try {
    return (await db.get("settings/models")) || {};
  } catch (e) {
    return {};
  }
};
